var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '../../dom';
import { Canvas } from '../../classes';
import './EffectsContainer.less';
var EffectsContainer = /** @class */ (function (_super) {
    __extends(EffectsContainer, _super);
    function EffectsContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.name = 'EffectsContainer';
        _this.afterEffects = {};
        _this.animate = function (time) {
            if (time && _this.time) {
                var dt = Math.min(100, time - _this.time);
                if (dt > 0)
                    _this.animateEffects(_this.afterEffects, dt);
            }
            _this.time = time;
            _this.draw();
            if (Object.values(_this.afterEffects).length) {
                requestAnimationFrame(_this.animate);
            }
            else {
                _this.unmount(document.body);
                _this.props.onDone();
            }
        };
        _this.el = _this.DIV('&', [(_this.scene = new Canvas(window.innerWidth, window.innerHeight)).canvas]);
        _this.mount(document.body);
        _this.afterEffects = _this.props.effects;
        requestAnimationFrame(_this.animate);
        return _this;
    }
    EffectsContainer.prototype.animateEffects = function (effects, dt) {
        for (var key in effects) {
            if (effects.hasOwnProperty(key)) {
                var effect = effects[key];
                effect.upd(dt);
                if (effect.isDone())
                    delete effects[key];
            }
        }
    };
    EffectsContainer.prototype.drawEffects = function (effects) {
        for (var key in effects) {
            if (effects.hasOwnProperty(key)) {
                effects[key].draw(this.scene);
            }
        }
    };
    EffectsContainer.prototype.draw = function () {
        this.scene.clear();
        this.drawEffects(this.afterEffects);
    };
    return EffectsContainer;
}(Component));
export { EffectsContainer };
